import React from 'react';
import PropTypes from 'prop-types';
import './faq-item.css';

const FaqItem = (props) => {
  const { question, answer, isOpen = false, className = '', ...rest } = props;

  return (
    <div
      data-faq={isOpen ? 'open' : 'closed'}
      className={`faq-item accordionContainer ${className}`}
      {...rest}
    >
      <div className='faq-item-header'>
        <h3 className='faq-item-question'>{question}</h3>
        <div className='faq-item-icon'>
          <svg viewBox='0 0 24 24' className='accordionIcon'>
            <path d='M7 10l5 5 5-5z' fill='currentColor' />
          </svg>
        </div>
      </div>
      <div className='accordionContent'>
        <div className='faq-item-answer'>{answer}</div>
      </div>
    </div>
  );
};

FaqItem.defaultProps = {
  question: '',
  answer: '',
  isOpen: false,
  className: '',
};

FaqItem.propTypes = {
  question: PropTypes.string.isRequired,
  answer: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  isOpen: PropTypes.bool,
  className: PropTypes.string,
};

export default FaqItem;
